import { Component, computed, inject, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { BlogService } from '../../services/blog.service';

const POSTS_PER_PAGE = 10;

@Component({
  selector: 'app-post-list',
  standalone: true,
  imports: [DatePipe],
  template: `
    <main>
      <header class="hero">
        <h1>Changelog</h1>
        <p>All the latest updates, improvements, and fixes to Publicatique</p>
      </header>

      @if (posts()) {
        <section class="entries">
          @for (post of visible(); track post.slug) {
            <article class="entry">
              <time class="entry__date" [dateTime]="post.date">
                {{ post.date | date:'d MMM, y' }}
              </time>
              <div class="entry__card">
                <h2 class="entry__title">{{ post.title }}</h2>
                <p class="entry__description">{{ post.description }}</p>
                <div class="entry__body" [innerHTML]="post.content"></div>
              </div>
            </article>
          }
        </section>

        @if (hasMore()) {
          <button type="button" class="load-more" (click)="loadMore()">
            Older updates
          </button>
        }
      } @else {
        <p class="loading">Loading…</p>
      }
    </main>
  `,
  styleUrl: './post-list.component.scss',
})
export class PostListComponent {
  private blog = inject(BlogService);
  private visibleCount = signal(POSTS_PER_PAGE);

  // toSignal without initialValue yields Signal<Post[] | undefined> — undefined renders the loading state.
  protected posts = toSignal(this.blog.getPostList());
  protected visible = computed(() => this.posts()?.slice(0, this.visibleCount()) ?? []);
  protected hasMore = computed(() => (this.posts()?.length ?? 0) > this.visibleCount());

  loadMore(): void {
    this.visibleCount.update(c => c + POSTS_PER_PAGE);
  }
}
